import { Theme } from '@mui/material/styles'
export const getStyles = (theme: Theme) => ({
  accordionContainer: {
    paddingBottom: theme.spacing(1.5),
  },

  accordionDetails: {
    display: 'block',
  },

  accordionSummary: {
    color: '#005aa3',
  },

  accordionTitle: {
    fontSize: '14px',
    fontFamily: 'Source Sans Pro Semibold',
  },

  body: {
    color: theme.palette.text.primary,
    fontFamily: 'Source Sans Pro',
    fontSize: '14px',
    lineHeight: '18px',
  },

  indicator: {
    backgroundColor: '#005aa3',
  },

  noContent: {
    fontFamily: 'Source Sans Pro Italic',
  },

  sectionHeading: {
    color: theme.palette.text.primary,
    fontFamily: 'Source Sans Pro Semibold',
    fontSize: '14px',
    lineHeight: '20px',
    '&:not(:first-child)': {
      marginTop: theme.spacing(2.4),
    },
  },

  tabContainer: {
    padding: theme.spacing(1.5),
  },
})
